export const creditLineRoute = (accountId: string | number) =>
	`/creditLine/${accountId}`;

export const financingRoute = (accountId: string | number) =>
	`/financing/${accountId}`;

export const extractRedirectPath = (): string | undefined => {
	try {
		const currentUrl = new URL(window.location.toString());
		const encodedRedirectPath = currentUrl.searchParams.get('redirectTo');
		return encodedRedirectPath ? decodeURI(encodedRedirectPath) : undefined;
	} catch {
		return undefined;
	}
};

export enum QrRepaymentParams {
	amount = 'amount',
	providerCode = 'providerCode',
}
type QrRepaymentUrlParams = {
	accountId: string | number;
	amount: number;
	providerCode: string;
};
export const qrRepaymentUrl = (params: QrRepaymentUrlParams): URL => {
	const url = new URL(
		`/qrRepayment/${params.accountId}`,
		window.location.origin
	);

	url.searchParams.append(QrRepaymentParams.amount, String(params.amount));
	url.searchParams.append(QrRepaymentParams.providerCode, params.providerCode);
	return url;
};
